import { deserialize } from 'cerialize'
import { SocketCommands, SocketMessageTypes, SocketChannel } from 'Modules/Socket'

export class SocketMessage {
	@deserialize public channel?: SocketChannel
	@deserialize public identifier?: string
	@deserialize public command?: SocketCommands
	@deserialize public type?: SocketMessageTypes
	@deserialize public message?: {
		type: string
		payload: {
			errors?: any
			success?: boolean
			request_id?: number
			shortname?: string
			purchasecode?: string
			[key: string]: any
		}
		params?: { [key: string]: any }
		[key: string]: any
	}
}
